export default {
      id: "message-usage",
      viewBox: "0 0 373.6 373.6",
      url: "/assets/svg/" + "sprite.svg#message-usage",
      toString: function () {
        return this.url;
      }
    }